import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Dashboard, Inventory, LocalShipping, Description } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import './BottomNav.css';

const BottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    // Determine current value based on path
    const getCurrentValue = () => {
        const path = location.pathname;
        if (path.startsWith('/dashboard')) return '/dashboard';
        if (path.startsWith('/pallets')) return '/pallets';
        if (path.startsWith('/recalls')) return '/recalls';
        if (path.startsWith('/incoming-deliveries')) return '/incoming-deliveries';
        return false;
    };

    const handleChange = (event, newValue) => {
        navigate(newValue);
    };

    return (
        <div className="bottom-nav-root">
            <BottomNavigation value={getCurrentValue()} onChange={handleChange} showLabels>
                <BottomNavigationAction
                    label={t('nav.dashboard')}
                    value="/dashboard"
                    icon={<Dashboard />}
                    className="bottom-nav-action"
                />
                <BottomNavigationAction
                    label={t('nav.pallets')}
                    value="/pallets"
                    icon={<Inventory />}
                    className="bottom-nav-action"
                />
                <BottomNavigationAction
                    label={t('nav.recalls')}
                    value="/recalls"
                    icon={<Description />}
                    className="bottom-nav-action"
                />
                <BottomNavigationAction
                    label={t('nav.incomingDeliveries')}
                    value="/incoming-deliveries"
                    icon={<LocalShipping />}
                    className="bottom-nav-action"
                />
            </BottomNavigation>
        </div>
    );
};

export default BottomNav;
